import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeNameMap = {
    '/admin-dashboard': 'Dashboard',
    '/play-management': 'Play Management',
    '/line-editing-modal': 'Line Editing',
    '/glossary-management': 'Glossary Management',
    '/user-management': 'User Management',
    '/analytics-dashboard': 'Analytics',
    '/site-settings': 'Site Settings'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Home', path: '/admin-dashboard' }];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeNameMap?.[currentPath] || segment?.split('-')?.map(word => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)
      )?.join(' ');
      
      breadcrumbs?.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="breadcrumb-container" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          
          return (
            <li key={crumb?.path} className="breadcrumb-item">
              {!isLast ? (
                <>
                  <Link to={crumb?.path} className="breadcrumb-link">
                    {crumb?.label}
                  </Link>
                  <Icon name="ChevronRight" size={16} className="breadcrumb-separator" />
                </>
              ) : (
                <span className="breadcrumb-current" aria-current="page">
                  {crumb?.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbTrail;